import { render, staticRenderFns } from "./NotificationBtn.vue?vue&type=template&id=9937c0fa"
import script from "./NotificationBtn.vue?vue&type=script&lang=js"
export * from "./NotificationBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports